export default "__VITE_ASSET__BIfzi2Nx__"